import { useQuery } from '@tanstack/react-query';
import { fancyShareQueryKey } from 'queries/fancyShare/queryKey';
import { FancyShareApi } from 'api/ApiHelper';

export const useGetLikedFancySharesQuery = (fancyShareIds: number[]) =>
  useQuery({
    queryKey: fancyShareQueryKey.fancyShareLikeList(fancyShareIds),
    queryFn: () => FancyShareApi.findFancyShareLikes(fancyShareIds),
    enabled: fancyShareIds.length > 0,
  });
